import PropTypes from 'prop-types';
import React from 'react';
import { Card } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Image from '../../assets/images/sur.jpg';
import './style.scss';

const SurveyCard = ({ title, description, slug }) => {
  const history = useHistory();
  const handleClick = () => {
    history.push(slug);
  };
  return (
    <Card border="danger" className="survey" onClick={handleClick}>
      <div className="ribbon"><span>VLU</span></div>
      <Card.Img variant="top" src={Image} alt={title} />
      <Card.Body>
        <Card.Title>
          <h4 className="survey-title_uppercase text-center">
            <span role="img" aria-label="&#128221;">&#128221; </span>
            {title}
          </h4>
        </Card.Title>
        <Card.Text className="description">
          {description}
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

SurveyCard.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string,
};

SurveyCard.defaultProps = {
  slug: 'cong-cu-holland'
};

export default SurveyCard;
